import { combineReducers } from 'redux';
import userProfile from './user-profile/reducer';
import sideMenu from './side-menu/reducer';

export default combineReducers({ userProfile, sideMenu });
